<template>
    <div class="navi-wrap">
        <div class="logo">
            <svg-icon name="logo" />
        </div>

        <i class="close" @click="close">
            <svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.225 0H3.895L0 3.895V5.22499L16.34 21.565L0 37.905V39.235L3.895 43.13H5.225L21.565 26.79L37.905 43.13H39.235L43.13 39.235V37.905L26.79 21.565L43.13 5.22499V3.895L39.235 0H37.905L21.565 16.34L5.225 0Z" />
            </svg>

        </i>
        <!-- @wheel.prevent
        @touchmove.prevent
        @scroll.prevent -->
        <swiper :modules="modules" :slides-per-view="'auto'" :centered-slides="true"
            :keyboard="{ enabled: true, onlyInViewport: false, }"
            :navigation="{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }" :loop="false">
            <swiper-slide>
                <nav class="navi" :class="{ 'open-search': is_open_search }">
                    <ul v-if="navi && navi.length !== 0">
                        <li v-for="(item, index) in navi" :key="item.ID" class="menu-item">
                            <Link v-if="item.title !== 'Search'" :link="item"
                                v-html="`<div><i>${index + 1}</i><span>${item.title}</span></div>`">
                            </Link>
                            <div v-else class="box" @click="openSearch(item, $event)">
                                <div>
                                    <i>9</i>
                                    <span>
                                        Search
                                    </span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="box" @click="toggle">
                                <div>
                                    <i>0</i>
                                    <span>
                                        Menu
                                    </span>
                                </div>
                            </div>

                        </li>
                    </ul>
                </nav>
            </swiper-slide>
            <swiper-slide>
                <div class="box-wrap">
                    <h2 class="title">Announcement</h2>
                    <ul class="news-list" v-if="news && news.length !== 0">
                        <li v-for="(item, index) in news" :key="item.ID" class="new-item">
                            <Link :to="item.link">
                            <time>{{ item.date }}</time>
                            <h3 v-html="item.post_title"></h3>
                            </Link>
                        </li>
                    </ul>
                </div>
            </swiper-slide>
            <!-- <swiper-slide>
                <div class="box-wrap">
                    <h2 class="title">Instagram</h2>
                    <ul class="feed-list" v-if="feeds && feeds.length !== 0">
                        <li v-for="(item, index) in feeds" :key="index" class="feed-item">
                            <a :href="item.permalink" target="_blank">
                                <img v-if="item.thumbnail_url" :src="item.thumbnail_url" />
                                <img v-else :src="item.media_url" />
                            </a>
                        </li>
                    </ul>
                </div>
            </swiper-slide> -->
            <span class="arrow swiper-button-prev">
                <svg-icon name="prev" />
            </span>
            <span class="arrow swiper-button-next">
                <svg-icon name="next" />
            </span>
            <span class="cursor" ref="cursor" :class="{ 'show': is_show }">{{ text }}</span>
        </swiper>
    </div>
</template>

<script>
import Link from '@/components/ui/Link.vue';
import Hover from '@/components/ui/Hover.vue';
import { convertToRelativeLink } from "@/utils/urlUtils.js";

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Keyboard } from 'swiper/modules';
import moment from 'moment';
import 'swiper/scss';


export default {
    name: 'Navi',

    data() {
        return {
            navi: [],
            news: [],
            feeds: [],
            is_open: false,
            is_open_search: false,
            is_sticky: false,
            keyword: '',
        }
    },



    setup() {
        return {
            modules: [Navigation, Keyboard],
        };
    },

    components: {
        Link,
        Hover,
        Swiper,
        SwiperSlide,
    },

    methods: {
        openSearch(item, e) {
            if (item.title === 'Search') {
                e.preventDefault();
                this.close();

                setTimeout(() => {
                    this.EventBus.emit('toggle-search');
                }, 350);
            }

        },

        open() {
            this.is_open = true;
            setTimeout(() => {
                document.documentElement.classList.add('disabled-scroll');
                document.body.classList.add('open-navi');
            }, 10);

        },

        close() {
            document.body.classList.remove('open-navi');

            setTimeout(() => {
                document.documentElement.classList.remove('disabled-scroll');
                this.is_open = false;
            }, 330);
        },

        toggle() {
            document.documentElement.classList.toggle('disabled-scroll');
            document.body.classList.toggle('open-navi');
        },

        keyEvent(event) {
            if (event.key !== 'Escape' && !document.body.classList.contains('open-navi')) return;

            switch (event.key) {
                case 'Escape':
                    if (document.body.classList.contains('open-navi')) {
                        document.body.classList.remove('open-navi');
                        document.documentElement.classList.remove('disabled-scroll');
                    }
                    break;

                case '0':
                    this.toggle();
                    break;

                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                    const index = (Number(event.key) - 1);
                    this.$router.push({
                        path: convertToRelativeLink(this.navi[index].url, window.globals.home_url)
                    });
                    break;


                case '8':
                    let url = '/support-us';
                    if (document.body.classList.contains('open-navi')) {
                        url = convertToRelativeLink(this.navi[7].url, window.globals.home_url);
                    }
                    this.$router.push({
                        path: url
                    });
                    break;

                case '9':
                    this.close();

                    setTimeout(() => {
                        this.EventBus.emit('toggle-search');
                    }, 350);
                    break;


                case '-':
                    // console.log(this.navi)
                    this.$router.push({
                        path: convertToRelativeLink(this.navi[9].url, window.globals.home_url)
                    });
                    break;

                case '+':
                case '=':
                    // console.log(this.navi)

                    this.$router.push({
                        path: convertToRelativeLink(this.navi[10].url, window.globals.home_url)
                    });
                    break;
            }
        }
    },

    mounted() {
        this.EventBus.on('toggle-navi', () => {
            this.toggle();

            // if (this.is_open) {
            //     this.close();
            // } else {
            //     this.open();
            // }
        });

        // window.addEventListener('keydown', (event) => {
        //     console.log('keydown', event)
        // });

        window.addEventListener('keydown', this.keyEvent);


        this.$ajax.get('/menus/20').then(res => {
            this.navi = res.data.items;
        });

        this.$ajax.get('/get-news').then(res => {
            res.data.posts.forEach(item => {
                const date = moment(item.post_date).format('DD MMMM, YYYY');
                item.date = date;
            });
            this.news = res.data.posts;
        });


        this.$ajax.get('/get-instagram-feed').then(res => {
            this.feeds = res.data.data.data;
        });
    },

}
</script>

<style lang="scss">
body.open-navi .navi-wrap {
    transform: translate(0, 0%);
}

.navi-wrap {
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(21px);
    transition: transform .3s ease-in-out;
    transform: translate(0, -100%);

    .close {
        position: absolute;
        right: var(--padding-x2);
        top: 12rem;
        height: 3rem;
        width: 3rem;
        cursor: pointer;
        z-index: 99;

        svg {
            display: block;
            height: 100%;
            width: 100%;
        }

        @media screen and (max-width: 768px) {
            top: 5rem;
            height: 2.4rem;
            width: 2.4rem;

        }
    }

    .logo {
        position: absolute;
        left: 0;
        top: 5vh;
        width: 90%;
        pointer-events: none;
        margin: 0 5%;

        &>svg {
            fill: var(--font-color);
            height: 15vh;
            width: 100%;
            display: block;
            margin: 0 auto;
        }


        @media screen and (max-width: 768px) {
            top: 4rem;
            width: 46rem;
            height: 10rem;
            margin: 0 auto;
            left: 50%;
            transform: translateX(-50%);

            svg {
                height: 100%;
                width: 100%;
            }
        }
    }

    .swiper {
        height: 100%;
        width: 100%;

        .arrow {
            position: absolute;
            top: 45%;
            height: 10vh;
            width: 10vh;
            cursor: pointer;
            z-index: 9;
            opacity: 1;
            transition: opacity .3s ease;

            svg {
                display: block;
                height: 100%;
                width: 100%;
            }

            &.swiper-button-next {
                right: 12.5vw;
            }

            &.swiper-button-prev {
                left: 13vw;
            }

            &.swiper-button-disabled {
                opacity: 0;
                pointer-events: none;
            }

            @media screen and (max-width: 1250px) {
                height: 6rem;
                width: 6rem;
                top: 50%;
                transform: translateY(-50%);

                &.swiper-button-next {
                    right: var(--padding);
                }

                &.swiper-button-prev {
                    left: var(--padding);
                }
            }
        }

        .swiper-slide {
            // display: flex;
            // align-items: center;
            // justify-content: center;
            padding: 25vh 0 0;
            width: 100vw;
            box-sizing: border-box;
            max-height: 100vh;
            overflow: auto;

            &::-webkit-scrollbar {
                width: 0px;
                height: 0px;
            }


            @media screen and (max-width: 768px) {
                padding: 20rem 0 0;
                width: 100%;

                &:nth-child(1) {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-top: 0;

                    .navi {
                        flex: 1;
                    }
                }
            }
        }

    }

    .navi {
        ul {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 60vh;
            margin: 1.5vh auto 0;

            @media screen and (max-width: 768px) {
                width: 90%;
                max-height: 70vh;
                margin: 0 auto;
                box-sizing: border-box;
                padding: 0 var(--padding-x4);
            }

            li {
                width: calc(33.33% - 3vh);
                height: 12vh;
                margin: 1.5vh;
                border-radius: 3vh;
                overflow: hidden;

                .box,
                a {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    width: 100%;
                    background-color: var(--theme-1);
                    color: white;
                    text-align: center;
                    line-height: 1;
                    font-weight: 400;
                    cursor: pointer;
                    transition: 0.5s;

                    @media screen and (max-width: 768px) {
                        border-radius: 2vh;
                    }

                    &:hover {
                        background-color: var(--theme-2);
                        transition: 0.5s;
                    }

                    &>div::before,
                    i {
                        font-size: 5.5vh;
                        display: block;
                        margin: 0;
                    }

                    span {
                        font-size: 1.9vh;
                    }
                }

                &:nth-child(10),
                &:nth-child(11) {
                    a {
                        background-color: black;
                    }

                    i {
                        display: none;
                    }
                }

                &:nth-child(10) {

                    a>div::before {
                        content: '_';
                        position: relative;
                        top: -2.3vh;
                    }
                }

                &:nth-child(11) {
                    order: 2;

                    a>div::before {
                        content: '+';
                    }
                }

                &:nth-child(12) {
                    .box {
                        background-color: var(--theme-2);
                    }
                }

                .router-link-exact-active {
                    background-color: var(--theme-2) !important;
                }

                @media screen and (max-width: 768px) {
                    width: 33.33%;
                    height: auto;
                    margin: 0;
                    position: relative;

                    &::before {
                        content: '';
                        display: block;
                        padding-top: 100%;
                    }

                    .box,
                    &>a {
                        position: absolute;
                        height: calc(100% - var(--padding));
                        width: calc(100% - var(--padding));
                        top: var(--padding-50);
                        left: var(--padding-50);

                        span {
                            font-size: var(--tiny-size);
                        }
                    }
                }
            }

        }
    }

    .box-wrap {
        width: 48vw;
        margin: 0 auto;
        padding-bottom: var(--padding-x2);

        @media screen and (max-width: 768px) {
            width: 100%;
        }

        .title {
            text-align: center;
            font-weight: normal;
            text-transform: uppercase;
            margin: var(--padding-x2) 0;
        }
    }


    .news-list {
        li {
            // margin: var(--padding-x2) 0;

            a {
                display: block;
                padding: var(--padding-x2);
                border-radius: 3rem;
                transition: 0.5s;

                &:hover {
                    background-color: var(--gray);
                    transition: 0.5s;
                }

                time {
                    font-size: var(--tiny-size);

                }

                h3 {
                    // margin-top: var(--padding-50);
                    font-size: var(--medium-size);
                    font-weight: normal;
                }
            }
        }

        @media screen and (max-width: 768px) {
            padding-left: 5rem;
            padding-right: 5rem;
        }
    }

    .feed-list {
        display: flex;
        flex-wrap: wrap;
        padding: var(--padding);

        li {
            width: 33.33%;
            box-sizing: border-box;
            padding: var(--padding);

            a {
                display: block;

                img {
                    display: block;
                    width: 100%;
                }
            }
        }
    }
}
</style>
